import { render, staticRenderFns } from "./QueueTicket2.vue?vue&type=template&id=03771e9f&scoped=true&"
import script from "./QueueTicket2.vue?vue&type=script&lang=js&"
export * from "./QueueTicket2.vue?vue&type=script&lang=js&"
import style0 from "./QueueTicket2.vue?vue&type=style&index=0&id=03771e9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03771e9f",
  null
  
)

export default component.exports